const list = {
  path: 'list',
  component: resolve => require(['../../../../../pages/user/course/importantnotice/list'], resolve)
}

export default list



// WEBPACK FOOTER //
// ./src/router/user/course/importantnotice/list/index.js